/**
 * Created by BFR on 26/07/2021.
 */
define('adminGlossariesController',[
  'module',
  'jquery',
  'underscore',
  'app',
  'adminGlossariesView',
  'settings',
  'bootbox',
  'entities/admin/glossaries'
], function(
  module,
  $,
  _,
  App,
  View,
  Settings,
  bootbox
) {
  'use strict';

  module.exports = {

    onGridLoaded: function() {
      var data = {
          url: App.request('glossaries:get-url'),
          rowCountUrl: App.request('glossaries:row-count-url')
        };

      this.view.displayGrid(data, true);
    },

    _showView: function() {
      this.view = new View({
      });

      this.view.listenTo(this.view, 'glossaries:remove', _.bind(this.onDelete, this));
      this.view.listenTo(this.view, 'onGridLoaded', _.bind(this.onGridLoaded, this));
      App.regions.getRegion('main').currentView.getRegion('content').show(this.view);
    },

    onDelete: function(secId){
        bootbox.confirm(_.i18n('customer.confirmDelete'), _.bind(function(result) {
            if(result){
                App.request('glossaries:delete', secId)
                    .done(_.bind(function(){
                        this.view.updatePagination(true);
                    }, this));
            }
        }, this));
    }
  };
});
